import { NgModule } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { registerLocaleData } from '@angular/common';
import * as de from '@angular/common/locales/de';
// tslint:disable-next-line:no-duplicate-imports
import * as _moment from 'moment';
import { default as _rollupMoment } from 'moment';

// Required for AOT compilation
export function TranslateHttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

const moment = _rollupMoment || _moment;

// See the Moment.js docs for the meaning of these formats:
// https://momentjs.com/docs/#/displaying/format/
export const MY_FORMATS = {
  parse: {
    dateInput: 'MM/YYYY',
  },
  display: {
    dateInput: 'DD.MM.YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@NgModule(/* TODO(standalone-migration): clean up removed NgModule class manually.
{ declarations: [AppComponent],
    bootstrap: [AppComponent], imports: [BrowserModule,
        MatDatepickerModule,
        CoreModule,
        ThemeModule,
        RoutesModule,
        SharedModule,
        FormlyConfigModule.forRoot(),
        NgxPermissionsModule.forRoot(),
        ToastrModule.forRoot(),
        QuillModule.forRoot({
            suppressGlobalRegisterWarning: true
        }),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: TranslateHttpLoaderFactory,
                deps: [HttpClient],
            },
        }),
        BrowserAnimationsModule], providers: [
        CsvService,
        { provide: BASE_URL, useValue: environment.baseUrl },
        { provide: LoginService, useClass: LoginService },
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
        },
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
        httpInterceptorProviders,
        appInitializerProviders,
        { provide: LOCALE_ID, useValue: 'de-DE' }, //Add the id and the language code here
        { provide: 'API_URL', useValue: environment.apiUrl },
        { provide: 'BASE_URL', useValue: environment.baseUrl },
        { provide: 'API_URL_PUBLIC', useValue: environment.apiUrlPublic },
        { provide: 'SERVER_URL', useValue: environment.serverUrl },
        { provide: 'VERSION', useValue: environment.version },
        { provide: 'PROD', useValue: environment.production },
        { provide: 'VERSION_DATE', useValue: environment.versionDate },
        { provide: 'APP_TITLE', useValue: environment.appTitle },
        { provide: 'SPONSOR_FIRST_YEAR', useValue: environment.sponsorFirstYear },
        provideHttpClient(withInterceptorsFromDi())
    ] } */)
export class AppModule {
  constructor() {
    registerLocaleData(de.default); //Then register the language
  }
}
